import React from 'react';
import { DayGroup, ActivityEvent } from '../../types';
import { isClickableEvent } from '../../utils/filterEvents/filterEvents';
import ActivityRow from '../ActivityRow/ActivityRow';

interface ActivityDayGroupProps {
  group: DayGroup;
  showActor: boolean;
  onActorClick: (userId: string) => void;
  onEventClick: (event: ActivityEvent) => void;
}

const ActivityDayGroup: React.FC<ActivityDayGroupProps> = ({
  group,
  showActor,
  onActorClick,
  onEventClick,
}) => {
  return (
    <div className='activity-day-group'>
      <div className='activity-day-header'>{group?.label}</div>
      <div className='activity-day-rail'>
        {group?.events.map((event) => (
          <ActivityRow
            key={event?.id}
            event={event}
            time={event?.time}
            actorName={showActor ? event?.userName : undefined}
            onActorClick={() => onActorClick(event?.userId)}
            onRowClick={
              isClickableEvent(event) ? () => onEventClick(event) : undefined
            }
          />
        ))}
      </div>
    </div>
  );
};

export default ActivityDayGroup;
